import { render, staticRenderFns } from "./ItemCategoryTabItems.vue?vue&type=template&id=40d33ac0&scoped=true&"
import script from "./ItemCategoryTabItems.vue?vue&type=script&lang=js&"
export * from "./ItemCategoryTabItems.vue?vue&type=script&lang=js&"
import style0 from "./ItemCategoryTabItems.vue?vue&type=style&index=0&id=40d33ac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d33ac0",
  null
  
)

export default component.exports